export const getters = {
    getPageById: (state) => (id) => state.hadiths.find((page) => page.id === id),
};
